module.exports = __webpack_public_path__ + "static/media/parent.02ecc0d0.png";